module.exports = __webpack_public_path__ + "img/map_3.de736dac.png";